export const USER_REQUEST = 'USER_REQUEST';
export const USER_REFRESH = 'USER_REFRESH';
export const USER_SUCCESS = 'USER_SUCCESS';
export const FLAGS_SUCCESS = 'FLAGS_SUCCESS';
export const ATTRIBUTES_SUCCESS = 'ATTRIBUTES_SUCCESS';
export const FOLDERS_SUCCESS = 'FOLDERS_SUCCESS';
export const TAGS_SUCCESS = 'TAGS_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
